import { Controller } from "remult";

@Controller("volunteer-organization-methods")
export class VolunteerOrganizationMethods {}
